import { isNotUndefined } from "@faire/web--source/common/typescriptUtils";
import { useObservable } from "@faire/web--source/ui/hooks/useObservable";
import * as React from "react";
import { useMemo } from "react";

import {
  ILeanBrandTileRendererBaseProps,
  LeanBrandTileRendererBase,
} from "@faire/retailer/components/LeanBrandTileRenderer/__internal__/LeanBrandTileRendererBase";

export const LeanBrandTileRendererForCarouselBase: React.FC<
  ILeanBrandTileRendererBaseProps
> = (props) => {
  const { brandTile } = props;

  const images = useObservable(() => brandTile?.images ?? []);
  const squareImage = useObservable(() => brandTile?.brand?.squared_image);

  const leanBrandTileForCarousel = useMemo(() => {
    if (!brandTile) {
      return undefined;
    }
    // carousel tile may render image from squared_image instead of images
    const [firstImage] = [...images, squareImage].filter(isNotUndefined);
    // TODO(Jude): report error if firstImage does not exist which can be an adapter bug
    return {
      ...brandTile,
      images: firstImage ? [firstImage] : [],
    };
  }, [brandTile, images, squareImage]);

  return (
    <LeanBrandTileRendererBase
      {...props}
      brandTile={leanBrandTileForCarousel}
    />
  );
};
